import React, { useState, useEffect } from "react";
import { Row, Col, Switch } from "antd";
import { useDispatch, useSelector } from "react-redux";

import {
  setUserPermissionsIsEdit,
  updateUserPermissions,
  updateUserSettings,
} from "../redux/actions";
import { ReactComponent as SaveIcon } from "../../../assets/save-icon.svg";
import { ReactComponent as EditIcon } from "../../../assets/edit-icon.svg";
import SpinnerComponent from "../../../components/spinner";
import PermissionsSection from "./permissionsSection";
import UseSupAdminOrAdminWithUserManagerPermission from "../../../components/useSupAdminOrAdminWithUserManagerPermission";

const GeneralPermissions = ({ isProfileCase, canUpdate }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({
    popup_notifications: false,
    email_notifications: false,
  });

  const [upperPermissions, setUpperPermissions] = useState({
    ims: { add_edit: false, view: false, export: false, delete: false },
    project_setup: {
      add_edit: false,
      view: false,
      export: false,
      delete: false,
    },
  });

  const [state, setState] = useState({
    default_doc_fields: { add_edit: false, view: false },
    departments: { add_edit: false, view: false },
    doc_types_manager: { add_edit: false, view: false },
    document_statuses: { add_edit: false, view: false },
    project_statuses: { add_edit: false, view: false },
    revision_statuses: { add_edit: false, view: false },
    user_manager: { add_edit: false, view: false },
  });
  let canEditEveryThing = UseSupAdminOrAdminWithUserManagerPermission();

  const {
    currentUserObj,
    popupLoading,
    emailLoading,
    permissionsLoading,
    userPermissionsIsEdit,
  } = useSelector((state) => state.userManagerReducer);

  useEffect(() => {
    if (currentUserObj?.id > 0) {
      const { popup_notifications, email_notifications } = currentUserObj;
      setData({
        popup_notifications,
        email_notifications,
      });

      if (currentUserObj?.permissions !== null) {
        const { ims, project_setup, ...rest } = currentUserObj.permissions;

        setState({ ...state, ...rest });
        setUpperPermissions({ ...upperPermissions, ims, project_setup });
      }
    }
  }, [currentUserObj]);

  const handleSave = () => {
    dispatch(
      updateUserPermissions({
        permissions: { ...upperPermissions, ...state },
        id: currentUserObj?.id,
      })
    );
  };

  const onChangeNotification = (key, checked, loadingObj) => {
    setData({ ...data, [key]: checked });
    const { id } = currentUserObj;
    dispatch(
      updateUserSettings({
        data: { id, [key]: checked },
        loadingObj,
      })
    );
  };

  return (
    <>
      <Row>
        <Col span={24} className="heading-col">
          <Row align="middle" justify="space-between">
            <Col>
              <div>
                <span className="heading-span">General Permissions</span>
              </div>
            </Col>
            {/* {!isProfileCase && canEditEveryThing && ( */}
            <Col>
              {userPermissionsIsEdit ? (
                permissionsLoading ? (
                  <SpinnerComponent fontSize={14} />
                ) : (
                  <SaveIcon width={16} height={16} onClick={handleSave} />
                )
              ) : (
                canUpdate && (
                  <EditIcon
                    width={16}
                    fill="#eb078e"
                    height={16}
                    onClick={() => dispatch(setUserPermissionsIsEdit(true))}
                  />
                )
              )}
            </Col>
            {/* )} */}
          </Row>
        </Col>
        <PermissionsSection
          state={state}
          setState={setState}
          upperPermissions={upperPermissions}
          setUpperPermissions={setUpperPermissions}
          readOnly={userPermissionsIsEdit}
        />

        <Col span={24} className="section-body settings-section">
          <Row
            align="middle"
            justify="space-between"
            className="simple-heading-col"
          >
            {/* <Col md={0} lg={2} xl={1} xxl={1}></Col> */}
            <Col md={23} lg={23} xl={23} xxl={23}>
              <div>
                <span className="heading-span">
                  General Permissions Notifications
                </span>
              </div>
            </Col>
          </Row>
          <Row style={{ paddingLeft: "12px" }}>
            <Col md={0} lg={2} xl={1} xxl={1}></Col>
            <Col md={8} lg={6} xl={4} xxl={4}>
              <div className="heading-text">Browser notifications</div>
              <div className="switch-parent-div">
                <span className={`${!data.popup_notifications && "off"}`}>
                  Off
                </span>{" "}
                <Switch
                  size="small"
                  defaultChecked={true}
                  checked={data.popup_notifications}
                  disabled={(currentUserObj?.id ? false : true) || popupLoading}
                  onChange={(e) =>
                    onChangeNotification("popup_notifications", e, {
                      popupLoading: false,
                    })
                  }
                />{" "}
                <span className={`${data.popup_notifications && "on"}`}>
                  On
                </span>
              </div>
            </Col>
            <Col>
              <div className="heading-text">Email notifications</div>
              <div className={"switch-parent-div"}>
                <span className={`${!data.email_notifications && "off"}`}>
                  Off
                </span>{" "}
                <Switch
                  size="small"
                  defaultChecked={true}
                  disabled={(currentUserObj?.id ? false : true) || emailLoading}
                  checked={data.email_notifications}
                  onChange={(e) =>
                    onChangeNotification("email_notifications", e, {
                      emailLoading: false,
                    })
                  }
                />{" "}
                <span className={`${data.email_notifications && "on"}`}>
                  On
                </span>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
export default GeneralPermissions;
